import { Component, input } from '@angular/core';
import { LocationState } from '../../store/locations.store';
import { LocationAddressPipe } from '../../pipes/location-address-pipe';
import { RandomColorPipe } from '../../../../shared/pipes/random-color-pipe';

@Component({
  selector: 'app-location-list-entry',
  imports: [LocationAddressPipe, RandomColorPipe],
  templateUrl: './location-list-entry.html',
})
export class LocationListEntry {
  location = input.required<LocationState>();
}
